<template>
    <div class="dialog-summary"> 
        <div style="background-color:white;border-radius:5px 5px 0 0" class="dialog-summary-main">
            <div class="header">
                <a class="close" @click="close">
                    <van-icon name="cross" />
                </a>
                <div class="title bg-main">
                    <span>{{ $t("translate.confirmation") }}</span>
                </div>
            </div>

            <div class="content">
                <div class="info-content bgwhite" >
                    <div v-if="order.isDelivery && serviceType.delivery_service == 'teleport'" class="bgwhite">
                        <p style="font-size:1.2rem">Estimated Time Arrival</p>
                        <span v-if="serviceType.choosedService.includes('INSTANT')" style="color: #ee2d24; font-weight: bolder">Within 1 Hours</span>
                        <span v-if="serviceType.choosedService.includes('FLASH')" style="color: #ee2d24; font-weight: bolder">Within 4 Hours</span>
                        <span v-if="serviceType.choosedService.includes('STANDARD')" style="color: #ee2d24; font-weight: bolder">More than 1 Day</span>
                    </div>

                    <div v-else-if="(order.isDelivery && serviceType.delivery_service == 'owntransport') || (order.isDelivery && serviceType.delivery_service == 'delyva') || (order.isDelivery && serviceType.delivery_service == 'lalamove')" class="bgwhite">
                      <div class="info-warning">
                        <h4 v-if="order.schedule.type" class="info-warning-text_pre">PRE-ORDER</h4>
                        <h4 v-else class="info-warning-text_now">NOW / ASAP</h4>
                      </div>
                      <p>Order Details</p>
                    </div>

                    <div v-else class="bgwhite">
                      <div class="info-warning">
                        <h4 v-if="order.schedule.type" class="info-warning-text_pre">PRE-ORDER</h4>
                        <h4 v-else class="info-warning-text_now">NOW / ASAP</h4>
                      </div>
                        <!-- <p v-if="order.isDelivery">Estimated Time Arrival</p>
                        <p v-else>Estimated Time Ready</p>
                        <p style="color: #ee2d24; font-weight: bolder; margin: 0; font-size: 16px;">{{dateETA}}</p>
                        <span style="color: #ee2d24; font-weight: bolder">{{fromETA}} - {{toETA}}</span> -->
                    </div>

                </div>

                <div class="delivery" v-if="order.isDelivery && serviceType.delivery_service == 'teleport'" style="font-size: 14px">
                    <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                        <div>
                            <icon v-if="serviceType.choosedService =='STANDARD_24'" color="#ee2d24" size="20px" name="plane"/>
                            <icon v-else-if="serviceType.choosedService.includes('BIKE')" color="#ee2d24" size="20px" name="motorcycle"/>
                            <icon v-else-if="serviceType.choosedService.includes('CAR')" color="#ee2d24" size="20px" name="car"/>
                        </div>
                        <div v-if="serviceType.choosedService == 'STANDARD_24'" style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_24',' COURIER')}}</div>
                        <div v-else-if="serviceType.choosedService.includes('BIKE')" style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_',' ')}}</div>
                        <div v-else style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_',' ')}}</div>
                    </div>
                </div>

                <div class="delivery" v-if="order.isDelivery && serviceType.delivery_service == 'lalamove'" style="font-size: 14px">
                    <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                        <div>
                            <icon v-if="serviceType.choosedService.includes('VAN')" color="#ee2d24" size="20px" name="plane"/>
                            <icon v-else-if="serviceType.choosedService.includes('BIKE')" color="#ee2d24" size="20px" name="motorcycle"/>
                            <icon v-else-if="serviceType.choosedService.includes('CAR')" color="#ee2d24" size="20px" name="car"/>
                            <icon v-else-if="serviceType.choosedService.includes('TRUCK')" color="#ee2d24" size="20px" name="truck"/>
                        </div>
                        <div v-if="serviceType.choosedService == 'STANDARD_24'" style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_24',' COURIER')}}</div>
                        <div v-else-if="serviceType.choosedService.includes('BIKE')" style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_',' ')}}</div>
                        <div v-else style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_',' ')}}</div>
                    </div>
                </div>

                <div class="delivery" v-if="order.isDelivery && serviceType.delivery_service == 'owntransport'" style="font-size: 14px">
                    <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                        <div>
                            <icon color="#ee2d24" size="20px" name="car"/>
                        </div>
                        <div style="padding-left: 16px; text-align: left;">OWN TRANSPORT</div>
                    </div>
                </div>

                <div class="delivery" v-if="order.isDelivery && serviceType.delivery_service == 'delyva'" style="font-size: 14px">
                    <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                        <div>
                            <van-icon color="#ee2d24" size="20px" name="logistics" />
                        </div>
                        <div style="padding-left: 16px; text-align: left;">{{serviceType.descService}}</div>
                    </div>
                </div>

                <div class="delivery" v-if="order.isDelivery && serviceType.delivery_service == 'tadago'" style="font-size: 14px">
                    <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                        <div>
                            <van-icon color="#ee2d24" size="20px" name="logistics" />
                        </div>
                        <div style="padding-left: 16px; text-align: left;">{{serviceType.descService}}</div>
                    </div>
                </div>

                <div class="schedule mt-2" v-if="order.schedule.datetime" :style="(order.isDelivery && serviceType.delivery_service == 'teleport') || (order.isDelivery && serviceType.delivery_service == 'lalamove') || (order.isDelivery && serviceType.delivery_service == 'owntransport') || (order.isDelivery && serviceType.delivery_service == 'delyva') || (order.isDelivery && serviceType.delivery_service == 'tadago')? 'display:none;':''" style="font-size: 14px">
                    <div style="display: flex; align-items: center; padding: 0 16px; margin:0;">
                        <div>
                            <van-icon class="buttonIcon" size="20px" name="clock-o" />
                        </div>
                        <div v-if="order.schedule.type" style="padding-left: 16px; text-align: left;">{{ $t("translate.schedule") }} ({{order.schedule.datetime | dateFormat('dddd, D MMM YYYY, HH:mm')}})</div>
                        <div v-else style="padding-left: 16px; text-align: left;">{{ $t("translate.instant") }}</div>
                    </div>
                </div>

                <div class="address" style="font-size: 14px" v-if="order.address">
                    <div style="display: flex; align-items: flex-start; padding: 0 8px 0 16px; margin:0;">
                        <div class="mt-1">
                            <van-icon class="buttonIcon" size="20px" name="location-o" />
                        </div>
                        <div style="padding-left: 16px; text-align: left;font-weight:600">{{order.address.address2 + ',' + order.address.address1}}</div>
                    </div>
                </div>

                <div class="personal" style="font-size: 14px" v-if="order.user">
                    <div class="source" v-if="order.user.name">
                        <div>
                            <van-icon class="buttonIcon" size="20px" name="user-o" />
                        </div>
                        <div style="padding-left: 16px; text-align: left;">{{order.user.name}}</div>
                    </div>
                    <div class="source" v-if="order.user.contact">
                        <div>
                            <van-icon class="buttonIcon" size="20px" name="phone-o" />
                        </div>
                        <div style="padding-left: 16px; text-align: left;">{{order.user.contact}}</div>
                    </div>
                    <div class="source" v-if="order.user.email">
                        <div>
                            <van-icon class="buttonIcon" size="20px" name="envelop-o" />
                        </div>
                        <div style="padding-left: 16px; text-align: left;">{{order.user.email}}</div>
                    </div>
                </div>
            </div>

            <div class="payment" style="font-size: 14px; border-top: 1px solid #ddd" v-if="payMethod.is_redirect">
                <div v-for="item in payMethod.available" :key="item">
                    <div>
                        <div class="sourcePay" style="display: flex; align-items: center; padding: 0 16px; margin: 3px 0;">
                            <div><input type="radio" :value="item" :id="item" v-model="choosedPayment"></div>
                            <label :for="item">
                            <div style="padding-left: 16px; text-align: left;">
                                <icon v-if="item.includes('Card')" color="#ee2d24" size="20px" name="credit-card"/>
                                <icon v-else-if="item.includes('Banking')" color="#ee2d24" size="20px" name="money-check-alt"/>
                                <icon v-else-if="item.includes('E-Wallet')" color="#ee2d24" size="20px" name="wallet"/>
                                <icon v-else color="#ee2d24" size="20px" name="wallet"/>
                            </div>
                            </label>
                            <label :for="item">
                            <div style="padding-left: 16px; text-align: left;">{{item}}</div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="slider">
                    <drag-verify 
                    :width="width"
                    :height="height" 
                    :text= "order.schedule.type ? '  Swipe to PRE-ORDER' : 'Swipe to Confirm'"
                    :success-text="successText" 
                    :background="background" 
                    :progress-bar-bg="progressBarBg" 
                    :completed-bg="completedBg" 
                    :handler-bg="handlerBg" 
                    :handler-icon="handlerIcon" 
                    :text-size="textSize" 
                    :success-icon="successIcon" 
                    :circle="getShape"
                    @passcallback="submit"></drag-verify>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import dragVerify from 'vue-drag-verify';
import moment from 'moment';
export default {
    components: {
        dragVerify
    },
    props: {
        confirm: {
            type: Function
        },
        cancel: {
            type: Function
        },
        store: {
            type: Object
        },
        order: {
            type: Object
        },
        isSubmit: {
            type: Boolean
        },
        serviceType: {
            type: Object
        },
        payMethod: {
            type: Object
        }
    },
    data() {
        return {
            background: '#cccccc',
            height:60,
            width: 280,
            text: 'Swipe to Confirm',
            successText: 'AWESOME!',
            color: '#fff',
            progressBarBg: '#ee2d24',
            completedBg: '#ee2d24',
            textSize: '14px',
            dateETA: '',
            fromETA: '',
            toETA: '',
            choosedPayment: '',
        }
    },
    created() {
        this.calculateETA();
        console.log('order',this.order)
        console.log('service type',this.serviceType)
        this.initCheck();
    },
    watch: {
        isSubmit: {
            deep: true,
            handler: function(newVal, oldVal) {
                this.calculateETA()
            }
        }
    },
    methods: {
        calculateETA() {
            console.log('calculate Eta')
            let eta = moment(this.order.schedule.datetime).toDate();
            let from, to;

            if(this.order.isDelivery) {
                from = moment(eta).add(this.order.etaInMinute/60, 'm');
                to = moment(eta).add(this.order.etaInMinute/60, 'm').add(15, 'm');
            } else {
                from = moment(eta);
                to = moment(eta).add(this.store.readyInMinute, 'm');
            }

            this.fromETA = from.utcOffset('+0800').format('HH:mm');
            this.toETA = to.utcOffset('+0800').format('HH:mm');
            this.dateETA = to.utcOffset('+0800').format('dddd, D MMM YYYY');
        },
        initCheck(){
            if (this.payMethod.is_redirect == 1){
                this.choosedPayment = this.payMethod.available[0];
            }
        },
        close() {
            this.dialog=false
            this.cancel();      
        },
        submit() {
            if (this.choosedPayment.includes('Card')){
                this.payMethod.choosedPayment = 'CC';
                this.payMethod.choosedChannel = 'GOBIZ';
            } else if (this.choosedPayment.includes('E-Wallet')){
                this.payMethod.choosedPayment = 'EW';
                this.payMethod.choosedChannel = 'RM';
            } else if (this.choosedPayment.includes('Banking')) {
                this.payMethod.choosedPayment = 'OB';
                this.payMethod.choosedChannel = 'REVPAY';
            }
            console.log('Confirm order...');
            this.confirm();
            sessionStorage.removeItem('select_time')
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.block {
    background-color: @white5;
    border-radius: 6px;
    width: 80%;
}

.flex {
    align-items: center;
    padding: 6px;
}

.icon-text {
    padding-left: 6px;
}

.dot {
    line-height: 6px;
    align-items: center;
    display: flex;
    justify-content: center;
    color: @main;
}

.title {
    text-align: center;
    padding: 16px 16px 10px 55px;
    font-weight: 700;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.content {
    padding: 0px;

    .v-application {
        background-color: @fff !important;
    }
}

.btn-action {
    display: flex;
    flex: 1;
    cursor: pointer;
}

// .btn-confirm {
//     height: 48px;
//     background-color: @main;
//     color: @fff;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     border-bottom-right-radius: 6px;
// }

.btn-cancel {
    height: 48px;
    background-color: @fff;
    color: @red;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-left-radius: 6px;
}

.personal{
    background-color: @fff;
    border-radius: 6px; 
    margin: 0 6px;
    .source{
        display: flex; 
        align-items: center; 
        padding: 3px 12px; 
        margin:  0;
        font-weight: bold;
        color: @gray5;
    }
}

.address, .schedule ,.delivery, .payment{
    margin: 0px; 
    padding: 3px 0; 
    background-color: @fff;
    border-radius: 6px;
    font-weight: bold;
    color: @gray5;
}

.info-content{
    text-align: center;
    padding: 16px;
    font-size: 20px;
    color: rgb(82, 82, 82);
    background-color: @fff !important;
    border-bottom: 1px solid @white10 !important;
    
    .v-application {
        background-color: @fff !important;
    }

    p{
        margin-bottom: 8px;
        margin-top: 12px;
        font-size: 16px;
    }
    .info-warning{
        h4{
            padding: 10px 20px;
            border-radius: 5px;
            display: inline-block;
        }
    }
}
.info-warning-text_pre{
    background-color:@yellow1;
    color:@fff;
    font-size:26px;
    font-family:roboto;
    margin-bottom:5px;
}
.info-warning-text_now{
    background-color:@green4;
    color:@fff;
    font-size:26px;
    font-family:roboto;
    margin-bottom:5px;
}
.info-content-ETA-text{
    color: @red; 
    font-weight: bolder;
    margin: 0; 
    font-size: 16px;
}
.info-content-ETA-detail{
    color: @red; 
    font-weight: bolder;
}

.close {
    float: right;
    padding: 17px;
    color: @fff;
}

.slider {
    margin: 0;
    padding: 6px 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>